import { API_PREFIX as API, API_ROUTES } from '../../../constants/api_routes';
import { APPOINTMENTS_ACTION_TYPES } from '../../actions/appointments/appointments_action';

const initialState = [];

export const mapAppointmentData = (appointment) => ({
	id: appointment?.uuid,
	startDate: new Date(appointment?.startDate),
	endDate: new Date(appointment?.endDate),
	title: appointment?.title,
    allDay: appointment?.allDay,
    article: {
        ...appointment?.article,
        '@id': `${API}${API_ROUTES.ARTICLES}/${appointment?.article?.uuid}`
    },
    price: appointment?.price,
    companyPrice: appointment?.companyPrice,
    doctorPrice: appointment?.doctorPrice,
    insuranceCompanyPrice: appointment?.insuranceCompanyPrice,
    technicianPrice: appointment?.technicianPrice,
    customer: appointment?.customer ? {
        ...appointment?.customer,
        '@id': `${API}${API_ROUTES.CUSTOMERS}/${appointment?.customer?.uuid}`
    } : null,
    worker: appointment?.worker ? {
        ...appointment?.worker,
        '@id': `${API}${API_ROUTES.WORKERS}/${appointment?.worker?.uuid}`
    } : null,
    technician: appointment?.technician ? {
        ...appointment?.technician,
        '@id': `${API}${API_ROUTES.WORKERS}/${appointment?.technician?.uuid}`
    } : null,
    insuranceCompany: appointment?.insuranceCompany ? {
        ...appointment?.insuranceCompany,
        '@id': `${API}${API_ROUTES.WORKERS}/${appointment?.insuranceCompany?.uuid}`
    } : null,
    digitalRecord: appointment?.digitalRecord[0],
    place: appointment?.place ? {
        ...appointment.place,
        ...appointment.place?.uuid && { '@id': `${API}${API_ROUTES.PLACES}/${appointment?.place?.uuid}` }
    } : null,
    placeUuid: appointment?.place?.uuid || -1,
    description: appointment?.description,
    isReservation: appointment?.isReservation,
    isOnline: appointment?.isOnline,
    isVestacenje: appointment?.isVestacenje,
    isZaveden: appointment?.isZaveden,
    isAbsent: appointment?.isAbsent,
    isPayed: appointment?.isPayed,
    payingDate: appointment.isPayed ? new Date(appointment?.payingDate ? appointment.payingDate : new Date()) : null,
    customerAttended: appointment?.customerAttended,
    rRule: appointment?.rRule
});

export const appointments = (state = initialState, action) => {
    switch (action.type) {
        case APPOINTMENTS_ACTION_TYPES.GET_APPOINTMENTS_SUCCESS:
            return action.payload.map(mapAppointmentData);
        case APPOINTMENTS_ACTION_TYPES.POST_APPOINTMENT_SUCCESS:
			return [mapAppointmentData(action.payload), ...state];
        case APPOINTMENTS_ACTION_TYPES.PUT_APPOINTMENT_SUCCESS: case APPOINTMENTS_ACTION_TYPES.GET_APPOINTMENT_SUCCESS: case APPOINTMENTS_ACTION_TYPES.PATCH_APPOINTMENT_SUCCESS:
            const updatedAppointment = action.payload;
            return [...state.map((appointment) => appointment.id !== updatedAppointment?.uuid ? appointment : { ...appointment, ...mapAppointmentData(updatedAppointment) })];
        case APPOINTMENTS_ACTION_TYPES.DELETE_APPOINTMENT_SUCCESS:
            const deletedAppointment = action.payload;
            return [...state.filter(appointment => appointment.id !== deletedAppointment)];
        default:
            return state;
    }
}
